module.exports = __webpack_public_path__ + "static/media/tanoshiitrail.62ef1ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/tanoshiitrail.png
// module id = 32
// module chunks = 0